module.exports = __webpack_public_path__ + "img/business listings.3d2066f2.svg";